<template>
  <b-container>
    <b-overlay :show="show" rounded="sm">
      <b-card class="mb-4">
        <template #header>
          <div class="d-flex justify-content-between align-items-center">
            <span>Información básica</span>
            <b-button v-if="isAdmin" variant="outline-primary" size="sm" @click="goToList">
              <i class="fas fa-list"></i> Listado
            </b-button>
          </div>
        </template>
        <b-form>
          <!-- Subtítulo: Información básica -->
          <b-row>
            <!-- CUIT -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group label="CUIT" label-for="cuit" class="label">
                <b-form-input
                  id="cuit"
                  v-model="editForm.cuit"
                  size="sm"
                  placeholder="Ejemplo: 20304050601"
                />
              </b-form-group>
            </b-col>

            <!-- Razón Social -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group
                label="Razón Social"
                label-for="companyName"
                class="label"
              >
                <b-form-input
                  id="companyName"
                  v-model="editForm.company_name"
                  size="sm"
                  placeholder="Nombre de la empresa"
                />
              </b-form-group>
            </b-col>

            <!-- Domicilio Fiscal -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group
                label="Domicilio Fiscal"
                label-for="taxDomicile"
                class="label"
              >
                <b-form-input
                  id="taxDomicile"
                  v-model="editForm.tax_domicile"
                  size="sm"
                  placeholder="Dirección fiscal"
                />
              </b-form-group>
            </b-col>

            <!-- Código Postal -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group
                label="Código Postal"
                label-for="postalCode"
                class="label"
              >
                <b-form-input
                  id="postalCode"
                  v-model="editForm.postal_code"
                  size="sm"
                  placeholder="Ejemplo: 1234"
                />
              </b-form-group>
            </b-col>

            <!-- Provincia -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group
                label="Provincia"
                label-for="province"
                class="label"
              >
                <b-form-select
                  id="province"
                  v-model="editForm.province_id"
                  :options="provinces"
                  size="sm"
                  @change="getCities(editForm.province_id)"
                />
              </b-form-group>
            </b-col>

            <!-- Ciudad -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group label="Ciudad" label-for="city" class="label">
                <b-form-select
                  id="city"
                  v-model="editForm.location_id"
                  :options="citiesFromProvince"
                  size="sm"
                />
              </b-form-group>
            </b-col>
            <!-- CBU -->
            <b-col cols="12" md="12" class="mb-3">
              <b-form-group label="CBU" label-for="cbu" class="label">
                <b-form-input
                  id="cbu"
                  v-model="editForm.cbu"
                  size="sm"
                  placeholder="Ejemplo: 0123456789012345678901"
                />
              </b-form-group>
            </b-col>
            <!-- Email -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group label="Email" label-for="email" class="label">
                <b-form-input
                  id="email"
                  type="email"
                  v-model="editForm.email"
                  size="sm"
                  placeholder="correo@ejemplo.com"
                />
              </b-form-group>
            </b-col>

            <!-- Teléfono -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group label="Teléfono" label-for="phone" class="label">
                <b-form-input
                  id="phone"
                  v-model="editForm.phone"
                  size="sm"
                  placeholder="Ejemplo: +5491145678901"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <div class="text-right mt-3">
            <b-button
              @click.prevent="updateProvider"
              size="sm"
              type="submit"
              variant="outline-primary"
              class="px-4 rounded-pill"
              title="Guardar cambios"
              :disabled="status === 'loading' || isDisableButtonSend"
            >
              <template v-if="status === 'idle'">
                <i class="fas fa-save mr-2"></i>
              </template>
              <template v-else-if="status === 'loading'">
                <i class="fas fa-spinner fa-spin mr-2"></i> Guardando...
              </template>
              <template v-else-if="status === 'success'">
                <i class="fas fa-check mr-2"></i> Guardado
              </template>
            </b-button>
          </div>
        </b-form>
      </b-card>
      <b-card class="mb-4">
        <template #header>
          <div class="d-flex justify-content-between align-items-center">
            <span>Archivos</span>
          </div>
        </template>
        <!-- Subtítulo: Archivos -->
        <p class="text-left text-muted small">
          La eliminación/agregado de archivos se guarda en el momento de
          realizar la acción.
        </p>
        <br />
        <!-- Inscripción frente al IVA -->
        <b-col cols="12">
          <b-row>
            <b-col cols="6">
              <b-form-group label="Condición frente a IVA" class="label">
                <b-form-radio-group
                  v-model="editForm.vat_condition"
                  :options="ivaOptions"
                  name="inscriptionIva"
                  stacked
                ></b-form-radio-group>
                <small
                  v-if="touched.inscriptionIva && !form.inscriptionIva"
                  class="text-danger"
                  >Debe seleccionar una opción</small
                >
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-row>
                <div>
                  <b-button
                    title="Agregar archivo"
                    size="sm"
                    variant="outline-primary"
                    @click="triggerFileInput('fileInputIva')"
                  >
                    <b-icon icon="plus"></b-icon>
                  </b-button>
                  <input
                    type="file"
                    ref="fileInputIva"
                    @change="addFile('iva', $event)"
                    style="display: none"
                  />
                </div>
                <template v-for="file in editForm.files">
                  <b-col v-if="file.type == 'iva'" :key="file.id" cols="3">
                    <div class="d-flex justify-content-between">
                      <!-- Vista previa del archivo -->
                      <div
                        style="width: 100px; height: 100px; overflow: hidden"
                      >
                        <img
                          v-if="isImage(file.path)"
                          :src="`${url}/${file.path.replace(
                            'public',
                            'storage'
                          )}`"
                          alt="file-preview"
                          class="img-thumbnail"
                          @click="openFile(file)"
                          style="
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            cursor: pointer;
                          "
                        />
                        <div
                          v-else
                          class="img-thumbnail d-flex justify-content-center align-items-center"
                          @click="openFile(file)"
                          style="
                            width: 100%;
                            height: 100%;
                            background-color: #f0f0f0;
                            cursor: pointer;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                          "
                        >
                          <span class="text-center">PDF</span>
                        </div>
                      </div>

                      <!-- Botón de eliminar -->
                      <i
                        class="ml-2 fas fa-trash-alt"
                        variant="danger"
                        size="sm"
                        @click="openModalDialogConfirmation(file)"
                        style="color: red; position: absolute; top: 0; right: 0"
                      ></i>
                    </div>
                  </b-col>
                </template>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <hr />
        <b-col cols="12">
          <b-row>
            <b-col cols="6">
              <b-form-group label="Inscripción en IIBB" class="label">
                <b-form-radio-group
                  v-model="editForm.iibb_registration"
                  :options="iibbOptions"
                  name="inscriptionIibb"
                  stacked
                ></b-form-radio-group>
                <small
                  v-if="touched.inscriptionIibb && !form.inscriptionIibb"
                  class="text-danger"
                  >Debe seleccionar una opción</small
                >
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-row>
                <div>
                  <b-button
                    title="Agregar archivo"
                    size="sm"
                    variant="outline-primary"
                    @click="triggerFileInput('fileInputIibb')"
                  >
                    <b-icon icon="plus"></b-icon>
                  </b-button>
                  <input
                    type="file"
                    ref="fileInputIibb"
                    @change="addFile('iibb', $event)"
                    style="display: none"
                  />
                </div>
                <template v-for="file in editForm.files">
                  <b-col v-if="file.type == 'iibb'" :key="file.id" cols="3">
                    <div class="d-flex justify-content-between">
                      <!-- Vista previa del archivo -->
                      <div
                        style="width: 100px; height: 100px; overflow: hidden"
                      >
                        <img
                          v-if="isImage(file.path)"
                          :src="`${url}/${file.path.replace(
                            'public',
                            'storage'
                          )}`"
                          alt="file-preview"
                          class="img-thumbnail"
                          @click="openFile(file)"
                          style="
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            cursor: pointer;
                          "
                        />
                        <div
                          v-else
                          class="img-thumbnail d-flex justify-content-center align-items-center"
                          @click="openFile(file)"
                          style="
                            width: 100%;
                            height: 100%;
                            background-color: #f0f0f0;
                            cursor: pointer;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                          "
                        >
                          <span class="text-center">PDF</span>
                        </div>
                      </div>

                      <!-- Botón de eliminar -->
                      <i
                        class="ml-2 fas fa-trash-alt"
                        variant="danger"
                        size="sm"
                        @click="openModalDialogConfirmation(file)"
                        style="color: red; position: absolute; top: 0; right: 0"
                      ></i>
                    </div>
                  </b-col>
                </template>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <hr />
        <b-col cols="12">
          <b-row>
            <b-col cols="6">
              <b-form-group
                label="Posee exenciones o exclusiones"
                class="label"
              >
                <b-form-radio-group
                  v-model="editForm.exemption"
                  :options="exemptionOptions"
                  name="exemption"
                  stacked
                ></b-form-radio-group>
                <small
                  v-if="touched.exemption && !form.exemption"
                  class="text-danger"
                  >Debe seleccionar una opción</small
                >
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-row>
                <div>
                  <b-button
                    title="Agregar archivo"
                    size="sm"
                    variant="outline-primary"
                    @click="triggerFileInput('fileInputExemp')"
                  >
                    <b-icon icon="plus"></b-icon>
                  </b-button>
                  <input
                    type="file"
                    ref="fileInputExemp"
                    @change="addFile('exemp', $event)"
                    style="display: none"
                  />
                </div>
                <template v-for="file in editForm.files">
                  <b-col v-if="file.type == 'exemp'" :key="file.id" cols="3">
                    <div class="d-flex justify-content-between">
                      <!-- Vista previa del archivo -->
                      <div
                        style="width: 100px; height: 100px; overflow: hidden"
                      >
                        <img
                          v-if="isImage(file.path)"
                          :src="`${url}/${file.path.replace(
                            'public',
                            'storage'
                          )}`"
                          alt="file-preview"
                          class="img-thumbnail"
                          @click="openFile(file)"
                          style="
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            cursor: pointer;
                          "
                        />
                        <div
                          v-else
                          class="img-thumbnail d-flex justify-content-center align-items-center"
                          @click="openFile(file)"
                          style="
                            width: 100%;
                            height: 100%;
                            background-color: #f0f0f0;
                            cursor: pointer;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                          "
                        >
                          <span class="text-center">PDF</span>
                        </div>
                      </div>

                      <!-- Botón de eliminar -->
                      <i
                        class="ml-2 fas fa-trash-alt"
                        variant="danger"
                        size="sm"
                        @click="openModalDialogConfirmation(file)"
                        style="color: red; position: absolute; top: 0; right: 0"
                      ></i>
                    </div>
                  </b-col>
                </template>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <div class="text-right mt-3">
          <b-button
            @click.prevent="updateProvider"
            size="sm"
            type="submit"
            variant="outline-primary"
            class="px-4 rounded-pill"
            title="Guardar cambios"
            :disabled="status === 'loading'"
          >
            <template v-if="status === 'idle'">
              <i class="fas fa-save mr-2"></i>
            </template>
            <template v-else-if="status === 'loading'">
              <i class="fas fa-spinner fa-spin mr-2"></i> Guardando...
            </template>
            <template v-else-if="status === 'success'">
              <i class="fas fa-check mr-2"></i> Guardado
            </template>
          </b-button>
        </div>
      </b-card>
      <b-card v-if="editForm.status != 'p'" class="mb-4">
        <template #header>
          <div class="d-flex justify-content-between align-items-center">
            <span>Observaciones</span>
          </div>
        </template>
        <!-- Sección: Historial de Observaciones -->
        <div
          style="
            max-height: 150pt;
            overflow-y: auto;
            border: 1px solid #ddd;
            border-radius: 10px;
            padding: 15px;
            background: #fff;
          "
        >
          <div
            v-if="editForm.observations.length === 0"
            class="text-muted text-center"
          >
            No hay observaciones registradas.
          </div>
          <div
            v-for="(obs, index) in editForm.observations"
            :key="index"
            class="mb-3"
          >
            <div
              :class="[
                'd-flex',
                obs.user_id === user.id
                  ? 'justify-content-end'
                  : 'justify-content-start',
              ]"
            >
              <div
                :style="{
                  backgroundColor:
                    obs.user_id === user.id ? '#e6f0ff' : '#e6ffe6',
                  color: obs.user_id === user.id ? '#003366' : '#006600',
                  maxWidth: '70%',
                  whiteSpace: 'pre-wrap',
                  padding: '12px',
                  borderRadius: '10px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  fontSize: '0.9rem',
                }"
              >
                <div align="left" class="mb-1 small font-weight-bold">
                  {{ obs.user.name }} • {{ obs.created_at }}
                </div>
                <div align="left">{{ obs.observation }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- Nueva observación -->
        <b-row class="mt-3">
          <b-col cols="12">
            <b-form-group>
              <b-form-textarea
                v-model="newObservation"
                placeholder="Escribí tu observación..."
                rows="3"
                size="sm"
                max-rows="12"
               maxlength="1500"
              ></b-form-textarea>
              <div align="right" style="font-size:8pt" variant="light">{{newObservation ? newObservation.length : 0}}-1500</div>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="text-right">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="addObservation"
              :disabled="!newObservation.trim()"
              class="rounded-pill px-4"
            >
              <i class="fas fa-comment-dots mr-2"></i> Agregar Observación
            </b-button>
          </b-col>
        </b-row>
      </b-card>
      <b-col v-if="(editForm.status != 'c' && editForm.status != 'p') && (editForm.user_id != user.id)" cols="12" class="text-center">
        <b-button
          size="sm"
          variant="success"
          @click="confirmProvider()"
          :disabled="editForm.user_id == user.id"
          class="rounded-pill px-4"
        >
          Confirmar Proveedor
        </b-button>
      </b-col>
      <br />
    </b-overlay>

    <b-modal
      id="modal-delete-file"
      title="Eliminar archivo"
      hide-footer
      centered
    >
      <b-container>
        <b-row>
          <b-col class="pt-3 pb-4">
            <h4 align="center">
              ¿Estás seguro que deseas eliminar el archivo?
            </h4>
          </b-col>
        </b-row>
        <b-row align-h="between">
          <b-col>
            <b-button
              variant="outline-secondary"
              @click="$bvModal.hide('modal-delete-file')"
            >
              Cancelar
            </b-button>
          </b-col>
          <b-col align="right">
            <b-button
              variant="outline-danger"
              @click="deleteFile(selectedFile.id)"
            >
              Eliminar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal id="success-modal" hide-header hide-footer centered>
      <b-container>
        <b-row>
          <b-col class="pt-3 pb-4" align="center">
            <h4>{{ msjModal }}</h4>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col align="center">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="$bvModal.hide('success-modal')"
            >
              Cerrar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-container>
</template>
  
<script>
import axios from "../../utils/axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      observations: [],
      newObservation: "",
      currentUser: { name: "Proveedor Mario", role: "admin" },
      isProvider: false,
      status: "idle", // idle, loading, success
      selectedFile: null,
      showModal: false,
      show: false,
      editForm: {
        province: {
          id: 0,
        },
        location: {
          id: 0,
        },
        observations: [],
        company_name: "",
        tax_domicile: "",
        postal_code: "",
      },
      provinces: [],
      cities: [],
      citiesFromProvince: [],
      selectedItem: {
        province: { name: null },
        location: { name: null },
      },
      ivaOptions: [
        { value: "ri", text: "RI (Responsable Inscripto)" },
        { value: "mt", text: "Monotributo" },
        { value: "ex", text: "Exento" },
      ],
      iibbOptions: [
        { value: "lo", text: "Local" },
        { value: "cm", text: "Convenio Multilateral" },
        { value: "nri", text: "No registra inscripción" },
      ],
      exemptionOptions: [
        { value: 1, text: "Si" },
        { value: 0, text: "No" },
      ],
      touched: {
        cuit: false,
        companyName: false,
        taxDomicile: false,
        postalCode: false,
        province: false,
        city: false,
        cbu: false,
        email: false,
        phone: false,
        inscriptionIva: false,
      },
      files: {
        iva: null,
        iibb: null,
        exemption: [],
      },
      selectedFile: null,
      url: "https://api.rup.antonioluquin.com.ar/",
      msjModal: "",
    };
  },
  computed: {
    isAdmin(){
      return this.editForm.user_id !== this.user.id;
    },
    isValidCUIT() {
      const cuitPattern = /^\d{2}\d{8}\d{1}$/;
      return cuitPattern.test(this.editForm.cuit);
    },
    isValidEmail() {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailPattern.test(this.editForm.email);
    },
    isDisableButtonSend() {
      const isDisabled = !(
        this.editForm.company_name.length > 0 &&
        this.editForm.tax_domicile.length > 0 &&
        this.editForm.postal_code.length == 4 &&
        this.editForm.cbu.length == 22 &&
        this.isValidEmail &&
        this.editForm.phone.length > 0 &&
        this.editForm.province_id &&
        this.editForm.location_id &&
        this.editForm.vat_condition &&
        this.editForm.iibb_registration &&
        this.editForm.exemption !== null &&
        this.isValidCUIT
      );
      return isDisabled;
    },
    ...mapGetters(["user"]),
  },
  mounted() {
    this.getProvider();
    this.getProvincesAndCities();
  },
  methods: {
    confirmProvider(){
      this.show = true;
      this.msgLoading = "Cargando...";
      axios
        .post("/providers/confirmProvider", {
          id: this.editForm.id,
        })
        .then((response) => {
          this.$router.push({ name: "providers/list" });
          this.show = false;
          this.msjModal = response.data.message;
          this.$bvModal.show("success-modal");
        })
        .catch((error) => {
          console.error("Error al confirmar proveedor:", error);
          this.show = false;
          this.msjModal = error.response.data.error || "Error al confirmar proveedor";
          this.$bvModal.show("success-modal");
        });
    },
    addObservation() {
      const observation = {
        user: this.user.name,
        userId: this.user.id,
        role: this.currentUser.role,
        date: new Date().toISOString(),
        observation: this.newObservation.trim(),
        providerId: this.editForm.id,
      };
      this.msgLoading = "Cargando...";
      this.show = true;
      axios
        .post("/providers/saveObservation", observation)
        .then((response) => {
          this.editForm.observations.push(response.data.observation);
          this.newObservation = "";
          this.show = false;
        })
        .catch((err) => {
          this.showLoading = false;
          this.msjModal = err.response.data.error;
          this.openMessageModal();
        });
    },
    getProviderId() {
      if (this.$route.params.id) {
        this.isProvider = false;
        return this.$route.params.id;
      } else {
        this.isProvider = true;
        return this.user.id;
      }
    },
    getProvider() {
      this.msgLoading = "Cargando...";
      this.show = true;
      const id = this.getProviderId();
      axios
        .get("/providers/getProvider", {
          params: {
            id: id,
            isProvider: this.isProvider,
          },
        })
        .then((response) => {
          this.editForm = response.data;
          this.show = false;
        })
        .catch((error) => {
          console.error("Error al obtener los datos del Proveedor:", error);
          this.show = false;
        });
    },
    getProvincesAndCities() {
      this.msgLoading = "Cargando...";

      this.show = true;
      axios
        .get("/getProvincesAndCities")
        .then((response) => {
          this.provinces = response.data.provinces;
          this.cities = response.data.cities;
          this.provinces.unshift({
            value: 0,
            text: "Seleccione una Provincia...",
          });
          //Asignamos los valores de proncincias y ciudades a las variables locales
          this.citiesFromProvince = this.cities.filter(
            (city) => city.province_id == this.editForm.province.id
          );
          this.show = false;
        })
        .catch((error) => {
          console.error("Error al obtener provincias:", error);
          this.show = false;
        });
    },
    getCities(provinceId) {
      this.citiesFromProvince = this.cities.filter(
        (city) => city.province_id == provinceId
      );
      this.citiesFromProvince.unshift({
        value: 0,
        text: "Seleccione una Ciudad...",
      });
      this.editForm.location_id = 0;
    },
    saveChanges() {
      // Aquí puedes hacer una petición API para guardar los cambios
      this.showEditModal = false;
    },
    formatKey(key) {
      const labels = {
        cuit: "CUIT",
        companyName: "Razón Social",
        taxDomicile: "Domicilio Fiscal",
        postalCode: "Código Postal",
        cbu: "CBU",
        email: "Email",
        phone: "Teléfono",
        province: "Provincia",
        city: "Ciudad",
        inscriptionIva: "Inscripción IVA",
        inscriptionIibb: "Inscripción IIBB",
        exemption: "Exención",
      };
      return labels[key] || key;
    },
    getFileUrl(path) {
      return `${this.url}/${path.replace("public", "storage")}`;
    },
    isImage(path) {
      return /\.(jpeg|jpg|gif|png)$/i.test(path);
    },
    isPdf(path) {
      return /\.pdf$/i.test(path);
    },
    openFile(file) {
      window.open(`${this.url}/${this.getStoragePath(file.path)}`, "_blank");
    },
    getStoragePath(path) {
      return path.replace("public", "storage");
    },
    deleteFile(fileId) {
      this.show = true;
      this.$bvModal.hide("modal-delete-file");
      axios
        .delete("/providers/deleteFile", {
          params: {
            fileId: fileId,
          },
        })
        .then((response) => {
          this.editForm.files = this.editForm.files.filter(
            (file) => file.id !== fileId
          );
          this.show = false;
          this.msjModal = response.data;
          this.$bvModal.show("success-modal");
        })
        .catch((error) => {
          console.error(error);
          this.show = false;
        });
    },
    triggerFileInput(inputRef) {
      this.$refs[inputRef].click();
    },
    addFile(type, event) {
      const file = event.target.files[0];
      if (file) {
        this.show = true;
        let formData = new FormData();
        formData.append("typeFile", type);
        formData.append("provider_id", this.editForm.id);
        formData.append("isProvider", !this.isAdmin);
        formData.append("file", file);

        axios
          .post("/providers/saveFile", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            //agregamos el archivo al array de archivos
            this.editForm.files.push(response.data);
            this.show = false;
            this.msjModal = "Archivo guardado con éxito";
            this.$bvModal.show("success-modal");
          })
          .catch((error) => {
            console.error(error);
            this.show = false;
          });
      }
    },
    updateProvider() {
      if (this.status === "loading") return;
      this.status = "loading";
      this.show = true;
      axios
        .put("/providers/update", this.editForm)
        .then((response) => {
          /*// Buscar el índice del proveedor en items y actualizarlo
          const index = this.items.findIndex(
            (item) => item.id === this.editForm.id
          );
          if (index !== -1) {
            this.$set(this.items, index, this.editForm);
          }*/
          this.status = "success";
          this.show = false;
          setTimeout(() => {
            this.status = "idle";
          }, 2000);
        })
        .catch((error) => {
          console.error("Error al actualizar proveedor:", error);
          this.status = "idle";
          this.show = false;
        });
    },
    openModalDialogConfirmation(file) {
      this.$bvModal.show("modal-delete-file");
      this.selectedFile = file;
    },
    goToList() {
      this.$router.push({ name: "providers/list" });
    },
  },
};
</script>
<style scoped>
.square-btn {
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px; /* Bordes cuadrados */
  font-size: 20px;
}
.label {
  font-size: 9pt !important;
  text-align: left;
  margin-bottom: 1pt !important;
}
</style>
  